<template>
	<div
		class="ao-badge-status"
		:class="[`ao-badge-status_${color}`, `ao-badge-status_${size}-size`]"
	>
		<div class="badge-status-content">
			<AoIcon
				v-if="prependIconName"
				:iconName="prependIconName"
			/>
			<slot>
				{{ text }}
			</slot>
			<AoIcon
				v-if="appendIconName"
				:iconName="appendIconName"
			/>
		</div>
	</div>
</template>

<script setup>
import AoIcon from './AoIcon.vue'

defineProps({
	color: {
		type: String,
		default: 'default',
		validator: (v) => ['success', 'warning', 'danger', 'info', 'default'].includes(v),
	},
	prependIconName: {
		type: String,
		default: null,
	},
	appendIconName: {
		type: String,
		default: null,
	},
	size: {
		type: String,
		default: 'default',
		validator: (v) => ['small', 'default', 'large', 'x-large'].includes(v),
	},
	text: {
		type: String,
	},
})
</script>

<style lang="scss">
@mixin badge-colors($color) {
	&_#{$color} {
		background-color: rgba(var(--v-theme-status-#{$color}-lighten-3), 0.25);
		color: rgb(var(--v-theme-status-#{$color}));
	}
}

@mixin badge-sizes($size) {
	&_#{$size}-size {
		border-radius: var(--#{$size}-radius);
		font-size: var(--#{$size}-fs);
		padding: var(--#{$size}-padding);
	}
}

.ao-badge-status {
	display: inline-block;
	font-weight: 500;
	align-self: baseline;

	// sizes
	--small-radius: 4px;
	--small-fs: 10px;
	--small-padding: 6px 4px;

	--default-radius: 6px;
	--default-fs: 10px;
	--default-padding: 6px;

	--large-radius: 8px;
	--large-fs: 12px;
	--large-padding: 6px 8px;

	--x-large-radius: 8px;
	--x-large-fs: 14px;
	--x-large-padding: 6px 8px;

	@include badge-colors('success');
	@include badge-colors('warning');
	@include badge-colors('info');
	@include badge-colors('danger');
	@include badge-colors('default');

	@include badge-sizes('small');
	@include badge-sizes('default');
	@include badge-sizes('large');
	@include badge-sizes('x-large');

	.badge-status-content {
		display: flex;
		gap: 2px;
		justify-content: center;
		align-items: center;
	}
}
</style>
